var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import { stopExperimentActionTypes } from "./Shutdown.ducks.js";
import { getDefaultAsyncWrapperObj, AsyncRequestStatus } from "@ane/core/lib/models";
const defaultReducerState = {
  experimentStop: getDefaultAsyncWrapperObj()
};
const reducer = (state = defaultReducerState, action) => {
  switch (action.type) {
    case stopExperimentActionTypes.LOADING:
      return __spreadProps(__spreadValues({}, state), {
        experimentStop: __spreadProps(__spreadValues({}, state.experimentStop), {
          status: AsyncRequestStatus.Pending
        })
      });
    case stopExperimentActionTypes.LOADED:
      const expStop = action;
      return __spreadProps(__spreadValues({}, state), {
        experimentStop: expStop.payload.result
      });
    default:
      return state;
  }
};
export {
  reducer as default,
  defaultReducerState,
  reducer
};
//# sourceMappingURL=Shutdown.reducer.js.map
